// extracted by mini-css-extract-plugin
export var buttons = "_b4-0";
export var buttonsActive = "_b4-h";
export var cancelConfirm = "_b4-1";
export var closeButton = "_b4-2";
export var column = "_b4-3";
export var container = "_b4-4";
export var detailHeader = "_b4-6";
export var detailTitle = "_b4-7";
export var detailsContent = "_b4-5";
export var header = "_b4-8";
export var headerWithClose = "_b4-9";
export var icon = "_b4-a";
export var infoIcon = "_b4-c";
export var informationContainer = "_b4-b";
export var sideDrawer = "_b4-d";
export var sideDrawerOpen = "_b4-e";
export var stickyFooter = "_b4-f";
export var typeOption = "_b4-g";